import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { cn } from '../lib/cn'
import { FieldShell, fieldDescribedBy, inputClass, useFieldId, type FieldChromeProps } from './field'

export type TextareaProps = FieldChromeProps & TextareaHTMLAttributes<HTMLTextAreaElement>

/** Labelled textarea: stable auto `id` + `htmlFor` (AUDIT_FIXES_JULY27 J1). */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hideLabel, help, error, size, wrapperClassName, id, className, required, ...rest },
  ref,
) {
  const fieldId = useFieldId(id)
  return (
    <FieldShell
      id={fieldId}
      label={label}
      hideLabel={hideLabel}
      help={help}
      error={error}
      required={required}
      wrapperClassName={wrapperClassName}
    >
      <textarea
        ref={ref}
        id={fieldId}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={fieldDescribedBy(fieldId, help, error)}
        className={cn(inputClass(size), 'w-full disabled:opacity-50', className)}
        {...rest}
      />
    </FieldShell>
  )
})
